import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import { SR_API_ACTION_ADMIN_UPDATE_ITEM } from 'api/actionTypes';

import postWithState from 'client/actions/postWithState';

import SrBox from 'client/components/SrBox';
import SrButton, {
  SR_BUTTON_THEME_ADOBE_BLUE,
  SR_BUTTON_THEME_ADOBE_GREEN,
} from 'client/components/SrButton/SrButton';
import SrText from 'client/components/SrText';
import SrDarkModal from 'client/components/SrDarkModal';
import SrModalContent from 'client/components/SrModalContent';
import SrFormikField, { SR_FIELD_THEME_ADOBE } from 'client/components/SrFormikField';

import './HitlistTaskListRow.less';

const formFieldTourFeedback = {
  id: 'feedback',
  title: 'Tour Feedback',
  type: 'long_text',
  properties: {
    noMargin: true,
    placeholder: 'Write here...',
  },
};

const HitlistTaskListRowTourFeedback = ({ review, dispatch, getHitlistTasks }) => {
  const [editFeedbackModalOpen, setEditFeedbackModalOpen] = useState(false);
  const openModal = () => setEditFeedbackModalOpen(true);
  const closeModal = () => setEditFeedbackModalOpen(false);

  const onSubmit = (formValues) => {
    dispatch(postWithState, {
      action: SR_API_ACTION_ADMIN_UPDATE_ITEM,
      payload: {
        table: 'reviews',
        where: {
          id: review.id,
        },
        updates: {
          feedback: formValues.feedback || null,
        },
      },
    }).then(() => {
      closeModal();
      getHitlistTasks();
    });
  };

  return (
    <div styleName="section">
      <span styleName="title">Tour Feedback</span>
      <SrBox padding="15px 0">
        <SrText font="greycliff" weight="500" size="16">
          {(review.feedback && `"${review.feedback}"`) || 'No tour feedback.'}
        </SrText>
      </SrBox>
      <SrButton theme={SR_BUTTON_THEME_ADOBE_BLUE} onClick={openModal} type="button" width="300px">
        Edit Feedback
      </SrButton>
      {editFeedbackModalOpen && (
        <SrDarkModal>
          <SrModalContent onCloseIconClick={closeModal}>
            <Formik
              enableReinitialize
              initialValues={{
                feedback: review.feedback || '',
              }}
              onSubmit={onSubmit}
              render={(formikBag) => {
                return (
                  <Form>
                    <SrFormikField
                      formField={formFieldTourFeedback}
                      formikBag={formikBag}
                      theme={SR_FIELD_THEME_ADOBE}
                    />
                    <SrButton theme={SR_BUTTON_THEME_ADOBE_GREEN} type="submit">
                      Save
                    </SrButton>
                  </Form>
                );
              }}
            />
          </SrModalContent>
        </SrDarkModal>
      )}
    </div>
  );
};

HitlistTaskListRowTourFeedback.propTypes = {
  review: PropTypes.object.isRequired,
  getHitlistTasks: PropTypes.func,
};

HitlistTaskListRowTourFeedback.displayName = 'HitlistTaskListRowTourFeedback';

export default HitlistTaskListRowTourFeedback;
